import { cloneDeep } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../mdae-framework";

export const TOGGLE_DOWNLOAD_POP_UP = "TOGGLE_DOWNLOAD_POP_UP";
export const SET_DOWNLOAD_POPUP_FORM_DATA = "SET_DOWNLOAD_POPUP_FORM_DATA";

export const LAYOUT_TYPES = {
  LANDSCAPE: "LANDSCAPE",
  PORTRAIT: "PORTRAIT",
};

export const LAYOUT = [
  { text: "Landscape", value: LAYOUT_TYPES.LANDSCAPE },
  { text: "Portrait", value: LAYOUT_TYPES.PORTRAIT },
];

export const downloadFormData = {
  orientation: LAYOUT_TYPES.LANDSCAPE,
  includeAISummary: false,
  includedTabId: [],
  isAllChecked: true,
  isProfessionalChecked: true,
  isOutpatientChecked: true,
  isInpatientChecked: true,
  footerLogo: true,
  includePageNumber: false,
  footerText: "",
  selectedVizIds: [],
};
const initialState = {
  isDownloadPopupOpen: false,
  downloadFormData: downloadFormData,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_DOWNLOAD_POP_UP:
      return {
        ...state,
        isDownloadPopupOpen: action.data.isDownloadPopupOpen,
      };
    case SET_DOWNLOAD_POPUP_FORM_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const downloadFormData = newState.downloadFormData
          ? cloneDeep(newState.downloadFormData)
          : {};
        for (let prop in action.data.downloadFormData) {
          downloadFormData[prop] = action.data.downloadFormData[prop];
        }
        newState = { ...newState, downloadFormData: downloadFormData };
      }
      return newState;
    default:
      return state;
  }
}
